<template>
    <div component="OrderHeader">
        <div class="line header">
            <div class="name">Name</div>
            <div>Type</div>
            <div>Length</div>
            <div>Territory</div>
            <div>Timespan</div>
            <div>Price</div>
        </div>
    </div>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex';

export default {
    name: 'OrderHeader',

    data() {
        return {};
    },

    async created() {},

    async mounted() {},

    methods: {
        ...mapActions([]),
        ...mapMutations([]),
    },

    computed: {
        ...mapGetters([]),
    },

    watch: {},

    components: {},
};
</script>

<style lang="less">
@import '~@variables';

[component='OrderHeader'] {
    .flex-column;
    width: 100%;

    .line {
        width: 100%;
        .flex-row;
        justify-content: space-between;

        div {
            text-align: center;
            padding: 8px 15px;
            flex-grow: 1;
            width: 20%;

            &.name {
                text-align: left;
            }
        }

        &.header {
            min-height: 45px;
            align-items: flex-end;

            div {
                padding-bottom: 5px;
            }
        }

        &.values {
            background-color: @grey_lt;
            border-radius: 10px 10px 0 0;
            color: @black;
            font-weight: bold;
            box-shadow: 0 3px 1px -2px rgba(0, 0, 0, 10%), 0 2px 2px 0 rgba(0, 0, 0, 14%),
                0 1px 15px 0 rgba(0, 0, 0, 15%) !important;

            div {
                padding: 10px 15px 6px;
            }

            .price {
                text-align: right;
            }
        }
    }
}
</style>
